import type { BankMessagesFeatureConfig } from './type';

export const base: BankMessagesFeatureConfig = {
    getMessageAcceptHeader: 'application/json',
};
